export default __webpack_public_path__ + "assets/webgl/scene-23.e21635c9.glb";